<template>
    <div :class="['tag', classObject]">
        <div class="tag__title"><slot></slot></div>
    </div>
</template>
<script>
export default {
    name: 'Tag',
    props: {
        theme: {
            type: String,
            default: 'peach',
            validator: prop => [
                'peach',
                'white',
                'gray',
                'gray-dark'
            ].includes(prop)
        },
        size: {
            type: String,
            validator: prop => ['m', 'l'].includes(prop),
            default: 'm'
        },
        rounded: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classObject () {
            return {
                [`tag--theme-${this.theme}`]: this.theme,
                [`tag--size-${this.size}`]: this.size,
                'tag--rounded': this.rounded
            }
        }
    }
}
</script>
<style lang="scss" src="./index.scss"></style>
